/* Built In Imports */

/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */
/* Config */
import { PageSectionV5St } from '@ieo/Common/CompLangConfig';

const findField = (sectionContent, fieldId) => {
  return sectionContent?.find(item => item.fieldId === fieldId);
};

const fieldIdMapper = {
  title: 'ieo-program-requirement-text',
  cards: 'program-requirement-cards',
};

const PageSectionV5 = ({ sectionContent, lang }) => {
  const cardsData =
    sectionContent && findField(sectionContent, fieldIdMapper.cards)?.cards;
  // console.log(cardsData, 'cards in cards');

  return (
    <Box
      backgroundColor={'#ffffff'}
      textAlign={'center'}
      py={{ base: '0.2rem', md: '0.8rem' }}
      px={{ base: '0.5rem', md: '0.8rem' }}
    >
      <Box maxW={'1080px'} w="full" mx="auto">
        <StructuredTextParser
          str={render(findField(sectionContent, fieldIdMapper.title)?.body)}
          color={'#3B444B'}
          fontFamily={'FedraSansStd-medium'}
          fontSize={{ base: '32px', md: '36px', lg: '36px' }}
          fontWeight={'500'}
          textAlign={'center'}
          // py="1rem"
          mx="auto"
          maxW={{
            base: '100%',
            sm: '435px',
            md: '740px',
            lg: '850px !important',
          }}
          // mt={{ base: '0', md: '40px' }}
        />
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          flexDirection={{ base: 'column', lg: 'row' }}
          gap={{ base: '50px', md: '40px', lg: '10px' }}
          py={{ base: 4, sm: 6, md: 10 }}
        >
          {cardsData?.map((card, index) => {
            return (
              <Box
                key={index}
                display={'flex'}
                alignItems={'center'}
                flexDirection={{ base: 'column', md: 'row' }}
                gap={{ base: '10px', md: '10px' }}
                maxW={{ base: '290px', sm: '300px', md: '450px' }}
                w="full"
                mx="auto"
              >
                <Image
                  src={card.thumbnail.url}
                  alt={card.thumbnail.alt}
                  mr={4}
                  w={{ base: '134px', md: '95px' }}
                  h={{ base: '134px', md: '95px' }}
                />
                <Box textAlign={{ base: 'center', sm: 'left' }} w="100%">
                  <Text
                    color={'#323232'}
                    fontFamily={'FedraSansStd-medium'}
                    fontSize={{ base: '18px', md: '22px' }}
                    lineHeight={{ base: '30px', md: '28.6px' }}
                    fontWeight={'500'}
                  >
                    {card.title}
                  </Text>
                  <StructuredTextParser
                    str={render(card.description.value)}
                    mt={{ base: '4px', md: '8px' }}
                    fontFamily={'FedraSansStd-book'}
                    fontSize={{ base: '16px', md: '16px' }}
                    lineHeight={'19.2px'}
                    fontWeight={'400'}
                    pt={1}
                    fontStyle="italic"
                    textAlign={{ base: 'center', sm: 'left' }}
                    whiteSpace={{ xl: 'nowrap' }}
                    {...PageSectionV5St[lang]}
                  />
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default PageSectionV5;
